import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  label: string;
  value: string | number;
  Icon: LucideIcon;
  color?: string;
  subtext?: string;
  pulse?: boolean;
}

export default function MetricCard({ label, value, Icon, color = 'var(--accent)', subtext, pulse }: MetricCardProps) {
  const iconBg = color.startsWith('var(') ? undefined : `${color}22`;

  return (
    <div style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 10,
      padding: '18px 20px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 14,
    }}>
      <div style={{
        width: 40,
        height: 40,
        borderRadius: 8,
        background: iconBg ?? 'var(--accent-subtle)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icon size={18} color={color} />
      </div>
      <div>
        <div style={{
          fontSize: 22,
          fontWeight: 700,
          color: 'var(--text)',
          lineHeight: 1.2,
          ...(pulse ? { animation: 'pulse 2s infinite' } : {}),
        }}>
          {value}
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{label}</div>
        {subtext && (
          <div style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 2 }}>{subtext}</div>
        )}
      </div>
    </div>
  );
}
